import { createAsyncThunk } from '@reduxjs/toolkit';
import { Reward } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindRewardHistory } from './interface';

export const findRewardHistory = createAsyncThunk(
  'rewardHistory/findRewardHistory',
  async (values: FindRewardHistory, { rejectWithValue }) => {
    try {
      const response = await Reward.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
